import React from "react";
import { translate } from "../../utils/translations/translate";
import { ConfirmationModal } from "../UI/ConfirmationModal";
const UserDeleteConfirmationModal = ({onConfirm,onClose}) => {
  return (
    <ConfirmationModal onClose={onClose} onConfirm={onConfirm} title={translate("labels.deleteResources")} infoText={translate("labels.deleteResourcesInfo")}  />
  );
};

export default UserDeleteConfirmationModal;
